import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion"
import { useIsMobile } from "@/hooks/use-is-mobile"

const FooterLinksBlock = ({ header, content, value }) => {
  const { isDesktop } = useIsMobile()

  if (isDesktop) {
    return (
      <div className="flex flex-col gap-5">
        <span className="font-poppins text-[18px] text-white">{header}</span>
        {content}
      </div>
    )
  }

  return (
    <Accordion type="multiple" collapsible className="w-full border-b border-[#ddd]">
      <AccordionItem value={value}>
        <AccordionTrigger arrowClassName="fill-white">
          {header}
        </AccordionTrigger>
        <AccordionContent>{content}</AccordionContent>
      </AccordionItem>
    </Accordion>
  )
}

export default FooterLinksBlock
